const searchStrip = {
  hotels: "Hoteles", // translated
  city: "Ciudad", // translated
  checkIn: "Registrarse", // translated
  checkOut: "Verificar", // translated
  date: "Fecha", // translated
  persons: "personas", // translated
  adults: "Adultos", // translated
  rooms: "Habitaciones", // translated
  editSearch: "Editar búsqueda", // translated
  newSearch: "Nueva búsqueda", // translated
  listView: "Vista de la lista", // translated
  mapView: "Vista del mapa", // translated
};

export default searchStrip;
